﻿import type { OrderPlacedDetailsProps } from 'components/secondaryMarket/cpOrder/sidePanel/orderPlaced/OrderPlacedDetails';
import { connect } from 'react-redux';
import { secondaryMarketCpOrderPlacementCloseThunk } from 'state/secondaryMarket/cpOrder/order/order.thunks';
import type { SecondaryMarketFormError } from 'state/secondaryMarket/shared/form/validationResults';
import {
  fromSecondaryMarket,
  getUserPreferencesSecondaryMarketCloseTabWhenOrderPlacedActivated,
} from 'state/selectors';
import { isSecondaryOrderBlotterVisible } from 'state/selectors/common/router';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

import type { OrderPlacedFormattingProps } from '../../../shared/SidePanel/useFormattedOrderPlaced';

type OwnProps = Readonly<{
  tabId: string;
  className?: string;
}>;

type StateProps = Readonly<OrderPlacedDetailsProps & OrderPlacedFormattingProps> & {
  hasOrderBlotter: boolean;
  validationErrors: SecondaryMarketFormError[];
  closeTabWhenLiveTradeCpOrderIsPlacedActivated: boolean;
};

type DispatchProps = Readonly<{
  onDone: (closeTab?: boolean) => void;
}>;

export type OrderPlacedSidePanelProps = OwnProps & StateProps & DispatchProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const tradeWay = fromSecondaryMarket.cpOrder.form.getFormTradeWay(state, tabId)!;
  const currency = fromSecondaryMarket.cpOrder.referential.product.getCpOrderBcsProductCurrency(state, tabId)!;
  const orderId = fromSecondaryMarket.cpOrder.order.getOrderId(state, tabId)!;
  const execTime = fromSecondaryMarket.cpOrder.order.getExecTime(state, tabId)!;
  const productIsin = fromSecondaryMarket.cpOrder.referential.product.getCpOrderBcsProductIsin(state, tabId);
  const fileCode = fromSecondaryMarket.cpOrder.referential.product.getCpOrderBcsProductFileCode(state, tabId);
  const productRic = fromSecondaryMarket.cpOrder.referential.product.getCpOrderBcsProductRic(state, tabId);
  const traderLabel = fromSecondaryMarket.cpOrder.referential.product.getCpOrderBcsProductTraderLabel(state, tabId);
  const quantity = fromSecondaryMarket.cpOrder.form.getFormQuantity(state, tabId);
  const cashAmount = fromSecondaryMarket.cpOrder.form.getFormCashAmount(state, tabId);
  const tradeDate = fromSecondaryMarket.cpOrder.order.getTradeDate(state, tabId);
  const cobDate = fromSecondaryMarket.cpOrder.order.getCobDate(state, tabId);
  const valuationDate = fromSecondaryMarket.cpOrder.order.getValuationDate(state, tabId);
  const settlementDate = fromSecondaryMarket.cpOrder.order.getSettlementDate(state, tabId);
  const validationErrors = fromSecondaryMarket.cpOrder.order.getOrderValidationErrors(state, tabId);
  return {
    orderId,
    tradeWay,
    traderLabel,
    tradeDate,
    settlementDate,
    productIsin,
    quantity,
    cashAmount,
    execTime,
    cobDate,
    valuationDate,
    currency,
    productRic,
    fileCode,
    hasOrderBlotter: isSecondaryOrderBlotterVisible(state),
    validationErrors,
    closeTabWhenLiveTradeCpOrderIsPlacedActivated:
      getUserPreferencesSecondaryMarketCloseTabWhenOrderPlacedActivated(state),
    formattedCashAmountLabel: 'secondaryMarket.sidePanel.label.cpPrice',
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): DispatchProps => {
  return {
    onDone: closeTab => {
      dispatch(secondaryMarketCpOrderPlacementCloseThunk(tabId, closeTab));
    },
  };
};

export const connectOrderPlacedSidePanel = connect(mapStateToProps, mapDispatchToProps);
